import { toast } from 'sonner';

const Alert = {
  show({
    message,
    level,
    ...options
  }: {
    message: string;
    level?: string;
    [key: string]: any;
  }) {
    if (level === 'success') return toast.success(message, options);
    if (level === 'error') return toast.error(message, options);
    if (level === 'warning') return toast.warning(message, options);
    return toast(message, options);
  },
  success(message: string) {
    return this.show({ message, level: 'success' });
  },
  error(message: string) {
    return this.show({ message, level: 'error' });
  },
};

export default Alert;
